import React from "react";
import { colors } from "stylesheets";

export default function({ color }) {
  const fill = colors[color] || colors.primary;
  return (
    <svg
      width="50"
      height="40"
      viewBox="0 0 50 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45 0H5C2.2425 0 0 2.2425 0 5V35C0 37.7575 2.2425 40 5 40H45C47.7575 40 50 37.7575 50 35V5C50 2.2425 47.7575 0 45 0ZM5 35V5H45L45.0025 35H5Z"
        fill={fill}
      />
      <path
        d="M10 10.0001H15V30.0001H10V10.0001ZM17.5 10.0001H20V30.0001H17.5V10.0001ZM37.5 10.0001H40V30.0001H37.5V10.0001ZM27.5 10.0001H35V30.0001H27.5V10.0001ZM22.5 10.0001H25V30.0001H22.5V10.0001Z"
        fill={fill}
      />
    </svg>
  );
}
